import { render, staticRenderFns } from "./tabCustomsInfoOuj.vue?vue&type=template&id=61d718c2&"
import script from "./tabCustomsInfoOuj.vue?vue&type=script&lang=js&"
export * from "./tabCustomsInfoOuj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d718c2')) {
      api.createRecord('61d718c2', component.options)
    } else {
      api.reload('61d718c2', component.options)
    }
    module.hot.accept("./tabCustomsInfoOuj.vue?vue&type=template&id=61d718c2&", function () {
      api.rerender('61d718c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/ouJian/tabCustomsInfoOuj.vue"
export default component.exports